class OrdersResource {
  getOrder(id, token) {
    return $.ajax({
      method: "GET",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/${id}.json`,
      data: {
        t: token
      },
      headers: st.resources.defaults.headers,
    });
  }

  createOrder(order) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia.json`,
      data: {
        order
      },
      headers: st.resources.defaults.headers,
    });
  }

  calculateOrder(order) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/calculate.json`,
      data: {
        order
      },
      headers: st.resources.defaults.headers,
    });
  }

  updateOrder(order) {
    return $.ajax({
      method: "PUT",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/${order.id}.json`,
      data: {
        t: order.token,
        order
      },
      headers: st.resources.defaults.headers,
    });
  }

  confirmOrder(order) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/${order.id}/confirm.json`,
      data: {
        t: order.token,
        order
      },
      headers: st.resources.defaults.headers,
    });
  }

  abandonOrder(id, token) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/${id}/abandon.json`,
      data: {
        t: token
      },
      headers: st.resources.defaults.headers,
    });
  }

  approveOrder(id, token) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/${id}/approve.json`,
      data: {
        t: token
      },
      headers: st.resources.defaults.headers,
    });
  }

  rejectOrder(id, token) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}zamowienia/${id}/reject.json`,
      data: {
        t: token
      },
      headers: st.resources.defaults.headers,
    });
  }

  createPaymentOperation(order_id, order_token, params = {}) {
    return $.ajax({
      method: "POST",
      url: `${st.GLOBALS.BACKEND_URL}platnosci.json`,
      data: {
        order_id,
        order_token,
        ...params
      },
      headers: st.resources.defaults.headers,
    });
  }
};

st.resources = st.resources || {}
const resource = st.resources.orders = new OrdersResource()
export default resource



// WEBPACK FOOTER //
// ./app/webpack/frontend/common/resources/OrdersResource.js